import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FitScreenIcon(props: IconProps) {
    return <Icon {...props} iconKey={"fit_screen"}/>
}
